import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4","key":"svg-0"}]]

const IconLetterRSmall = createReactComponent('outline', 'letter-r-small', 'LetterRSmall', __iconNode);

export default IconLetterRSmall;